import { PatientOrderControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchiveOrder = () =>
  useMutationWithLoading(
    async (params: {
      patientOrderId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientOrderControllerApi(
        getConfigObject()
      ).updatePatientOrderArchiveStatus(
        params?.patientOrderId,
        params?.status,
        params?.xTENANTID
      )
  );
